import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// 1. IMPORT ROUTER COMPONENTS
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import IntroOverlay from "./Components/IntroOverlay/IntroOverlay";
import "./App.css";
import whatsappImg from "./assets/whatsapp.png";

import ClientSection from "./Components/ClientSection/ClientSection";
import ScrollStack from "./Components/ScrollStack/ScrollStack";
import BrandIdentity from "./Components/ScrollStack/ScrollComponents/BrandIdentity/BrandIdentity";
import UiUx from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Ui&Ux";
import Digital from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Digital";
import PhotoVideoSection from "./Components/ScrollStack/ScrollComponents/BrandIdentity/PhotoVideo";
import PrintSignage from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Print";
import Campaigns from "./Components/ScrollStack/ScrollComponents/BrandIdentity/Campaigns";
import Testimonials from "./Components/Testimonials/Testimonials";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/AboutUs/AboutUs";
import Navbar from "./Components/Navigation/Navigation";
import { VelocityText } from "./Components/ScrollStack/ScrollComponents/WhatWeBuild/WhatWeBuild";
import FullAbout from "./Components/About/FullAbout"; // Ensure this path is correct
import Works from "./Components/Works/Work";
import WorkDetail from "./Components/Works/CanineCrownDetail";
import MgrDetail from "./Components/Works/MgrDetail";
import WindplusDetail from "./Components/Works/WindplusDetail";
import FestonDetail from "./Components/Works/FestonDetail";
import AtssDetails from "./Components/Works/AtssDetails";
import AulphaDetails from "./Components/Works/AulphaDetails";
import PlugzmartDetails from "./Components/Works/PlugzmartDetails";
import SmileauraDetails from "./Components/Works/SmileauraDetails";
import GangaSweetsDetails from "./Components/Works/GangaSweetsDetails";
import VelammalNexuxDetails from "./Components/Works/VelammalNexuxDetails";
import SwathyDetails from "./Components/Works/SwathyDetails";
import JKBDetails from "./Components/Works/JKBDetails";
import ApramattDetails from "./Components/Works/ApramattDetails";
import ContactStack from "./Components/ContactPage/ContactPage";
import FullContact from "./Components/ContactUs/ContactUs";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import SmoothScroll from "./Components/SmoothScroll/SmoothScroll";
import HeroVideo from "./Components/Hero1/Hero1";
import Team from "./Components/Team/Team";
/* import BlogList from "./Components/Blog/BlogList";
import BlogPost from "./Components/Blog/BlogPost"; */

// Analytics Page Tracker component
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const serverUrl = isLocalhost ? "http://localhost:5000" : "https://ascentbw.com";
    
    const path = location.pathname;
    let title = "Home";
    
    if (path.startsWith("/works/")) {
      const workName = path.replace("/works/", "").replace(/-/g, " ");
      title = `Work - ${workName.charAt(0).toUpperCase() + workName.slice(1)}`;
    } else if (path === "/about") {
      title = "About Us";
    } else if (path === "/works") {
      title = "Our Works";
    } else if (path === "/contact") {
      title = "Contact Us";
    } else if (path === "/client") {
      title = "Our Clients";
    } else if (path === "/blog") {
      title = "Blog";
    } else if (path.startsWith("/blog/")) {
      title = "Blog Post";
    }
    
    fetch(`${serverUrl}/api/track/pageview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ path, title })
    }).catch(err => console.warn("Page tracking failed:", err));
  }, [location]);

  return null;
};
/* import WorkSection from "./Components/ProjectSection/worksection";
 */
function App() {
  const [loading, setLoading] = useState(true);

  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // --- FIX: Defined the missing sectionStyle variable ---
  const sectionStyle = { scrollMarginTop: "100px" };

  return (
    <Router>
      <PageTracker />
      <SmoothScroll>
        <div className="App">
          {loading ? (
            <IntroOverlay />
          ) : (
            <Routes>
              {/* ROUTE 1: HOME PAGE (Your existing one-page layout) */}
              <Route
                path="/"
                element={
                  <>
                    <ScrollToTop />
                    <Navbar />

                    <section id="home" style={sectionStyle}>
                      <HeroVideo />
                    </section>

                    {/* ID: home */}
                    {/*  <section id="home" style={sectionStyle}>
                      <Hero />
                    </section> */}

                    <ClientSection />

                    {/* ID: about */}
                    <section style={sectionStyle}>
                      <AboutUs />
                    </section>



                    {/* ID: services (ScrollStack) */}
                    <section id="services" style={sectionStyle}>
                      <ScrollStack>
                        <BrandIdentity />
                        <UiUx />
                        <Digital />
                        <PhotoVideoSection />
                        <PrintSignage />
                        <Campaigns />
                        <VelocityText />
                      </ScrollStack>
                    </section>

                    {/* <section id="workSection" style={sectionStyle}>
                      <WorkSection />
                    </section> */}



                    <Testimonials/>

                    {/* ID: contact (inside Footer usually, but if you have a separate section add it here) */}

                    <section
                      id="footer"
                      style={sectionStyle}
                    >
                      <Footer onContactClick={() => setShowContact(true)} />

                      {/* The Contact Stack Section */}
                      {showContact && (
                        <ContactStack onClose={() => setShowContact(false)} />
                      )}
                    </section>

                    {/* Fixed WhatsApp Icon */}
                    <a
                      href="https://wa.me/7540001028"
                      className="whatsapp-float"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        position: "fixed",
                        bottom: "30px",
                        right: "20px",
                        zIndex: 9999,
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={whatsappImg}
                        alt="WhatsApp Chat"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      />
                    </a>
                  </>
                }
              />

              {/* ROUTE 2: THE NEW FULL ABOUT PAGE */}
              <Route path="/about" element={<FullAbout />} />
              <Route path="/works" element={<Works />} />
              <Route path="/works/canine-crown" element={<WorkDetail />} />
              <Route path="/works/mgr" element={<MgrDetail />} />
              <Route path="/works/windplus" element={<WindplusDetail />} />
              <Route path="/works/feston" element={<FestonDetail />} />
              <Route path="/works/atss" element={<AtssDetails />} />
              <Route path="/works/aulpha" element={<AulphaDetails />} />
              <Route path="/works/plugzmart" element={<PlugzmartDetails />} />
              <Route path="/works/smileaura" element={<SmileauraDetails />} />
              <Route path="/works/gangasweets" element={<GangaSweetsDetails />} />
              <Route path="/works/velammalnexux" element={<VelammalNexuxDetails />} />
              <Route path="/works/swathy" element={<SwathyDetails />} />
              <Route path="/works/jkb" element={<JKBDetails />} />
              <Route path="/works/apramatt" element={<ApramattDetails />} />
              <Route path="/contact" element={<FullContact />} />
              <Route path="/client" element={<Team />} />
             {/*  <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} /> */}
            </Routes>
          )}
        </div>
      </SmoothScroll>
    </Router>
  );
}

export default App;
